import { Slider } from "ant-design-vue"
const { ...other } = Slider

const YwSlider = {
  ...other,
  name: "YwSlider",
}

YwSlider.install = function (Vue) { 
  Vue.component(YwSlider.name, Slider);
}

export default YwSlider